import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchNotesIfNeeded } from '../actions/notes';
import Notes from '../components/Notes';

const mapStateToProps = state => ({
  notes: state.notes.notes,
  fetching: state.notes.fetching,
  parts: state.book.book ? state.book.book.parts : []
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      fetchNotes: fetchNotesIfNeeded
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Notes);



// WEBPACK FOOTER //
// ./src/containers/NotesContainer.js